import { render } from "./agent.chats.vue?vue&type=template&id=faf878a2"
import script from "./agent.chats.vue?vue&type=script&lang=js"
export * from "./agent.chats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__